import * as React from "react";

export const isActionEventObjectValue = (
    value: unknown,
): value is Record<string, unknown> =>
    typeof value === "object" && value !== null;

const renderObjectRows = (obj: Record<string, unknown>) =>
    Object.keys(obj).map((key) => (
        <tr key={key}>
            <td>{key}</td>
            <td>{renderObjectValue(obj[key])}</td>
        </tr>
    ));

const renderObjectValue = (value: unknown): React.ReactNode => {
    if (Array.isArray(value)) {
        return (
            <>
                {value.map((item, index) => (
                    <React.Fragment key={index}>
                        {renderObjectValue(item)}
                    </React.Fragment>
                ))}
            </>
        );
    }

    if (isActionEventObjectValue(value)) {
        return (
            <table className="at-object-table">
                <tbody>{renderObjectRows(value)}</tbody>
            </table>
        );
    }

    if (typeof value === "boolean") {
        return value ? "true" : "false";
    }

    if (value === null || value === undefined) {
        return undefined;
    }

    return String(value);
};

export const getActionEventObjectTable = (obj: unknown) => {
    if (!isActionEventObjectValue(obj)) {
        return renderObjectValue(obj);
    }

    return (
        <table className="at-object-table">
            <tbody>{renderObjectRows(obj)}</tbody>
        </table>
    );
};
